import React from 'react';
import PropTypes from 'prop-types';
import './RecordDetails.scss';

const RecordDetails = ({ items }) => (
  <dl className="record-details">
    {items.filter(item => item.value !== null && item.value !== undefined && item.value !== '').map(item => (
      <div className="record-details-item" key={`record-details-${item.label}`}>
        <dt>{item.label}</dt>
        <dd>{item.value}</dd>
      </div>
    ))}
  </dl>
);

RecordDetails.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })).isRequired,
};

export default RecordDetails;
